"use strict";
exports.__esModule = true;
exports.getPriceForPassenger = exports.getSeatCellsForPassengers = exports.isTrain = exports.isBus = void 0;
/* eslint-disable no-labels */
var vehicles_1 = require("./vehicles");
/**
 * Type guard to determine if the departure is a bus.
 * @param departure Departure
 */
function isBus(departure) {
    return !departure.vehicle_type || departure.vehicle_type === vehicles_1.VehicleType.Bus;
}
exports.isBus = isBus;
/**
 * Type guard to determine if the departure is a train.
 * @param departure Departure
 */
function isTrain(departure) {
    return departure.vehicle_type === vehicles_1.VehicleType.Train;
}
exports.isTrain = isTrain;
/**
 * Get all the seat cells from the vehicle for the passengers
 *
 * @param departure the departure
 * @param passengers all the passengers to find seats
 * @returns a map for with each index being the passenger ID and value being the seat selected.
 * If the vehicle layout is not present returns undefined
 */
function getSeatCellsForPassengers(departure, passengers) {
    // TODO update to work with trains
    if (!isBus(departure))
        throw new Error("Function does not work for non-buses yet");
    var num_passengers = passengers.length;
    var found_seats = {};
    var vehicle = departure.bus || departure.vehicle || departure.details.bus || departure.details.vehicle;
    if (!vehicle || !vehicle.floors) {
        return;
    }
    floor_loop: for (var _i = 0, _a = vehicle.floors; _i < _a.length; _i++) {
        var floor = _a[_i];
        for (var _b = 0, _c = floor.cells; _b < _c.length; _b++) {
            var cells = _c[_b];
            var _loop_1 = function (cell) {
                if (cell.type === "seat") {
                    var passenger = passengers.find(function (passenger) { return cell.id === passenger.selected_seat; });
                    if (passenger) {
                        found_seats[passenger.id] = cell;
                        if (Object.keys(found_seats).length === num_passengers) {
                            return "break-floor_loop";
                        }
                    }
                }
            };
            for (var _d = 0, cells_1 = cells; _d < cells_1.length; _d++) {
                var cell = cells_1[_d];
                var state_1 = _loop_1(cell);
                switch (state_1) {
                    case "break-floor_loop": break floor_loop;
                }
            }
        }
    }
    return found_seats;
}
exports.getSeatCellsForPassengers = getSeatCellsForPassengers;
/**
 * Returns the price for the category or the adult price
 * @param prices
 * @param category
 */
function getPrice(prices, category) {
    return prices[category] || prices.adult;
}
/**
 * Returns the price a passenger has paid for the departure, checking the seats in the bus if the price is not available
 * @param departure The full departure on which the passenger travels
 * @param passenger a single passenger
 * @param seats optional, the map of passenger / seats. If not passed, will lookup. You can get one with calling getSeatCellsForPassengers()
 * @returns the price the passenger paid
 */
function getPriceForPassenger(departure, passenger, seats) {
    seats = seats || getSeatCellsForPassengers(departure, [passenger]);
    var category = passenger.category;
    if (!seats || !seats[passenger.id] || !seats[passenger.id].prices) {
        return getPrice(departure.prices.categories, category);
    }
    return getPrice(seats[passenger.id].prices, category);
}
exports.getPriceForPassenger = getPriceForPassenger;
